var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m9.031 12.938-.687.687c-.313.281-.781.281-1.063 0L1.22 7.531a.684.684 0 0 1 0-1.031L7.28.406a.774.774 0 0 1 1.063 0l.687.688c.313.312.281.781 0 1.093L5.25 5.75h9a.76.76 0 0 1 .75.75v1a.74.74 0 0 1-.75.75h-9l3.781 3.594c.281.312.313.781 0 1.094Z",
  fill: "#878E95"
})));
export default SvgArrowLeft;